import { useAuth } from '@guildeducationinc/guild-auth';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { clickable } from '@src/analytics';
import { JOB_POSTINGS_LABEL } from '@src/constants';
import useGetPublicEmployerInfo from '@src/hooks/useGetPublicEmployerInfo';
import { makePossessive } from '@src/utilities/format';
import './EmployerCareerSection.scss';

const EmployerCareerSection: React.FC = () => {
  const { user } = useAuth();
  const { employerResources } = useGetPublicEmployerInfo();

  // "carer" and "job" checks can be removed after this has been completed:
  // https://guild-education.atlassian.net/browse/EPOL-356
  const careerResourceLink = employerResources?.find(
    (resource) =>
      resource?.type === 'career' || resource?.type?.toLowerCase() === 'career exploration url'
  )?.value;
  const jobBoardLink = employerResources?.find(
    (resource) => resource?.type === 'job' || resource?.type?.toLowerCase() === 'job board url'
  )?.value;

  const handleClick = (text: string) => {
    clickable({
      product: 'home',
      loggedIn: true,
      tag: 'careers_section',
      text,
      type: 'link',
    });
  };

  return (
    <div>
      {jobBoardLink && (
        <div className='employerResource'>
          <TextLink
            href={jobBoardLink}
            onClick={() => handleClick('employer_job_postings')}
            size='large'
            target='_blank'
            variant='standalone'
          >
            {user?.employerName} job postings
          </TextLink>
          <Typography variant='label2'>{JOB_POSTINGS_LABEL}</Typography>
        </div>
      )}

      {careerResourceLink && (
        <div className='employerResource'>
          <TextLink
            href={careerResourceLink}
            onClick={() => handleClick('employer_career_resources')}
            size='large'
            target='_blank'
            variant='standalone'
          >
            {user?.employerName} career resources
          </TextLink>
          <Typography variant='label2'>
            Dig into {makePossessive(user?.employerName)} career resources.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default EmployerCareerSection;
